const animationStyle = `
.ai-dots {
  overflow: visible;
}
@keyframes ai-dots-3 {
  0% { animation-timing-function: linear; opacity: -0.1; }
  63% { animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1); opacity: -0.1; }
  66% { animation-timing-function: linear; opacity: 1.1; }
  100% { opacity: 1.1; }
}
.ai-dots #ai-dots-3 {
  animation: ai-dots-3 1s linear infinite;
}
@keyframes ai-dots-2 {
  0% { animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1); opacity: 0; }
  30.1% { animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1); opacity: -0.1; }
  33% { animation-timing-function: linear; opacity: 1.1; }
  100% { opacity: 1.1; }
}
.ai-dots #ai-dots-2 {
  animation: ai-dots-2 1s linear infinite;
}
@keyframes ai-dots-1 {
  0% { animation-timing-function: linear; opacity: 1; }
  50% { animation-timing-function: linear; opacity: 1.049; }
  100% { opacity: 1.1; }
}
.ai-dots #ai-dots-1 {
  animation: ai-dots-1 1s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
  .ai-dots * {
    animation: none !important;
  }
}
`

const DOT_PATH =
  'M1.472 3.072C1.04533 3.072 0.693334 2.92267 0.416 2.624C0.138667 2.32533 0 1.96267 0 1.536C0 1.088 0.138667 0.719999 0.416 0.431999C0.693334 0.143999 1.04533 0 1.472 0C1.888 0 2.23467 0.143999 2.512 0.431999C2.78933 0.719999 2.928 1.088 2.928 1.536C2.928 1.96267 2.78933 2.32533 2.512 2.624C2.23467 2.92267 1.888 3.072 1.472 3.072Z'

const AiDots = () => {
  return (
    <svg
      className='ai-dots shrink-0'
      width='14'
      height='19'
      viewBox='0 0 14 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <style>{animationStyle}</style>
      <g transform='translate(0 13)'>
        <path id='ai-dots-3' transform='translate(10.4063 0)' d={DOT_PATH} fill='#E5004C' />
        <path id='ai-dots-2' transform='translate(5.20314 0)' d={DOT_PATH} fill='#E5004C' />
        <path id='ai-dots-1' d={DOT_PATH} fill='#E5004C' />
      </g>
    </svg>
  )
}

export default AiDots
